module.exports = __webpack_public_path__ + "img/0e286f3.png";